import AddFaq from './AddFaq'
export default AddFaq